module.exports = __webpack_public_path__ + "static/img/2.6297777.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/sp/2.png
// module id = 2GBF
// module chunks = 0